import { NOTIFICATION_SETTINGS_VARIANT } from './notifications.constants'
import { useQueryNotificationsSettings } from './notifications.query'
import { components } from '../../../generated'

export const useSelectSetAllSettingsState = (
  type: components['schemas']['AlertServiceType']
) => {
  const { data: notificationSettingsJob } = useQueryNotificationsSettings(type)

  const valuesJob = Object.values(notificationSettingsJob ?? {}).flatMap(
    (val) => Object.values(val ?? {})
  )

  if (!valuesJob) {
    return NOTIFICATION_SETTINGS_VARIANT.ALL
  }

  const isInternalJob = valuesJob.every(
    (val) => NOTIFICATION_SETTINGS_VARIANT.INTERNAL === val
  )

  const isDisabledJob = valuesJob.every(
    (val) => NOTIFICATION_SETTINGS_VARIANT.DISABLED === val
  )

  const isEmailJob = valuesJob.every(
    (val) => NOTIFICATION_SETTINGS_VARIANT.EMAIL === val
  )

  const isAllJob = valuesJob.every(
    (val) => NOTIFICATION_SETTINGS_VARIANT.ALL === val
  )

  if (isInternalJob) {
    return NOTIFICATION_SETTINGS_VARIANT.INTERNAL
  }

  if (isDisabledJob) {
    return NOTIFICATION_SETTINGS_VARIANT.DISABLED
  }

  if (isEmailJob) {
    return NOTIFICATION_SETTINGS_VARIANT.EMAIL
  }

  if (isAllJob) {
    return NOTIFICATION_SETTINGS_VARIANT.ALL
  }

  return NOTIFICATION_SETTINGS_VARIANT.CUSTOM
}
